// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignupForm_Form__W5xFG","Text":"SignupForm_Text__G8YE1"};